module.exports = __webpack_public_path__ + "static/media/500.c3cb2d0e.svg";